import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';

const ContactPage = () => {
  useEffect(() => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "name": "Contact NGP Renovatieproject",
      "url": `${import.meta.env.VITE_SITE_URL ?? ''}/contact`,
      "description": "Neem contact op met NGP Renovatieproject voor een vrijblijvende offerte of meer informatie over onze renovatiediensten in Antwerpen en omgeving.",
      "mainEntity": {
        "@type": "LocalBusiness",
        "name": "NGP Renovatieproject",
        "telephone": "+3210231886",
        "email": "ngp.renovatieprojecten@gmail.com",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Adelaarstraat 55 B301",
          "addressLocality": "Merksem",
          "postalCode": "2170",
          "addressCountry": "BE"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 51.2397,
          "longitude": 4.4297
        },
        "hasMap": "https://www.google.com/maps/dir/?api=1&destination=Adelaarstraat+55,+2170+Merksem,+Belgi%C3%AB"
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-contact';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById('schema-contact');
      if (existing) existing.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ContactHero />
      <div className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <ContactForm />
            <ContactInfo />
          </div>
        </div>
      </div>

      {/* Google Maps sectie */}
      <div className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="mb-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'serif' }}>
              Onze Locatie
            </h2>
            <p className="text-gray-600 text-sm">Adelaarstraat 55 B301, Merksem 2170</p>
          </div>
          <div className="w-full rounded-2xl overflow-hidden shadow-md" style={{ height: '420px' }}>
            <iframe
              title="NGP Renovatieprojecten locatie"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2497.3!2d4.4297!3d51.2397!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c3f6b0b0b0b0b1%3A0x0!2sAdelaarstraat%2055%2C%202170%20Merksem!5e0!3m2!1snl!2sbe!4v1700000000000!5m2!1snl!2sbe&q=Adelaarstraat+55,+2170+Merksem,+Belgi%C3%AB"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <div className="mt-6 flex items-center gap-3">
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=Adelaarstraat+55,+2170+Merksem,+Belgi%C3%AB"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 bg-gray-900 text-white px-6 py-3 rounded-lg text-sm font-medium hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-navigation-line text-sm"></i>
              </div>
              Route plannen
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ContactPage;
